import { render } from "./training-calender.vue?vue&type=template&id=764ab2ba&scoped=true"
import script from "./training-calender.vue?vue&type=script&lang=js"
export * from "./training-calender.vue?vue&type=script&lang=js"

import "./training-calender.vue?vue&type=style&index=0&id=764ab2ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764ab2ba"]])

export default __exports__